import styled, { space } from '@styled'
import { Container } from 'react-bootstrap'

export const Containerwrap = styled(
  /* eslint-disable no-unused-vars */
  ({ p, px, py, pt, pb, pl, pr, m, mx, my, mt, mb, ml, mr, ...rest }) => (
    /* eslint-enable no-unused-vars */
    <Container {...rest} />
  )
)`
  ${space};
`
